export const COURSE_CATEGORIES = [
  "IT & Software",
  "Software Development",
  "Design",
  "Business",
  "Marketing",
  "Healthcare & Medical",
  "Finance & Accounting",
  "Engineering & Manufacturing",
  "Education & Training",
  "Sales & Marketing",
  "Human Resources",
  "Administration & Office Support",
  "Customer Service",
  "Hospitality & Tourism",
  "Logistics & Supply Chain",
  "Design & Creative",
  "Media & Communications",
  "Legal",
  "Science & Research",
  "Construction & Trades",
  "Retail & Consumer Goods",
  "Data Science & Analytics",
  "Banking & Insurance",
  "Telecommunications",
  "Government & Public Sector",
  "NGO & Non-Profit",
  "Real Estate",
  "Automotive",
  "Agriculture & Farming",
  "Energy & Utilities",
  "Fashion & Apparel",
  "Food & Beverage",
  "Security & Law Enforcement",
  "Aviation & Aerospace",
  "Marine & Shipping",
  "Sports & Fitness",
  "Gaming & Animation",
  "Digital Marketing",
  "Content Writing",
  "Travel & Leisure",
  "E-commerce",
  "Cybersecurity",
  "Cloud Computing",
  "Quality Assurance",
  "Project Management",
  "Art & Photography",
  "Music & Entertainment",
  "Interior Design",
  "Social Services",
  "Mining & Extraction",
  "Event Management",
  "Others"
];
